import { JSX, RefObject, useRef } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    TextField,
    SelectInput,
    DateInput,
    DateField,
    ReferenceField,
    required,
    ReferenceManyField,
    Datagrid,
    EditButton,
    Pagination,
    useRecordContext,
    BooleanField
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { emailMessageDirectionOptions, emailMessageStatuses } from "../../defaults/defaults";
import { RichTextEditor, RichTextEditorRef } from "mui-tiptap";
import { Extensions } from "@tiptap/core";
import useExtensions from "./components/NokMini/admin-mini/hooks/extension-hooks";
import EditorControls from "./components/NokMini/admin-mini/components/EditorControls";
import { useFormContext } from "react-hook-form";
import DOMPurify from 'dompurify';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const EditorPanel: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    const rteRef: RefObject<RichTextEditorRef> = useRef<RichTextEditorRef>(null);
    const extensions: Extensions = useExtensions();
    let timer: any;
    const form: any = useFormContext();

    const onChangeContent: (value: any) => void = (value: any): void => {
        const text: string = rteRef.current.editor.getHTML();
        if (record?.bodyHtml === text) return;
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout( (): void => {
            let cleanHtml: string  = DOMPurify.sanitize(
                text,
                {
                    WHOLE_DOCUMENT: true,
                    ADD_TAGS: ['head', 'meta', 'body', 'title', 'DOCTYPE']
                }
            );
            form?.setValue('bodyHtml', cleanHtml, { shouldDirty: true });
        }, 500 );
    };

    return (
        <RichTextEditor
            // editable={ props.disableEditor }
            ref={ rteRef }
            extensions={ extensions }
            content={ record?.bodyHtml }
            renderControls={ EditorControls }
            onUpdate={ onChangeContent }
            className="ms_editor__container"
            // onBlur={ richTextEditorBlur }
            sx={ { overflowY: 'auto' } }
        />
    );
}

export const EmailMessagesEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <TextInput name="subject" source="subject" validate={[required()]} />
                        <EditorPanel />
                        <TextInput name="body" source="body" validate={[required()]} multiline rows={ 15 } />
                    </Grid>
                    <Grid size={ 6 }>
                        <TextInput name="sender" source="sender" />
                        <TextInput name="recipient" source="reciient" />
                        <SelectInput source="direction" choices={ emailMessageDirectionOptions } validate={[required()]} />
                        <SelectInput source="status" choices={ emailMessageStatuses } validate={[required()]} />
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Opened" }</span>
                            <DateField source="opened" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Delivered" }</span>
                            <DateField source="delivered" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } } >
                            <span>{ "Created" }</span>
                            <DateField source="createdAt" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Message ID" }</span>
                            <TextField source="messageId"  />
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
